module.exports = __webpack_public_path__ + "img/nocturna.6bee5194.png";